var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta"},[_c('vb-button',{staticClass:"cta__btn",attrs:{"vb_options":{
      text: 'Continua',
      variant: 'info',
      icon_disabled: 'lock_v2',
      disabled: _vm.cta_status.disabled || !_vm.get_availability(_vm.property_data.live_price).can_go_to_checkout
    }},on:{"click":function($event){return _vm.scroll_to_bottom()}}}),(_vm.cta_status.disabled)?_c('div',{class:'cta__text text-' + _vm.cta_status.variant},[_c('vb-icon',{staticClass:"cta__text-icon mr-1",attrs:{"name":'info',"color":_vm.sass(_vm.cta_status.variant),"size":14}}),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.cta_status.label)}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }